//style okendo reviews
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const okendo_total_text = document.querySelectorAll(".oke-sr-total-text");

    if (okendo_total_text.length > 0) {
      okendo_total_text.forEach((review) => {
        review.innerHTML = review.innerHTML.replace(/[()]/g, "");
      });
    }
  }, 1000);
});

class DynamicCollection extends HTMLElement {
  constructor() {
    super();

    // change the filter title accordingly, for growthbook test
    this.filterLabelForGrowthbook = "Availability";
    this.queryString = window.location.search;
    this.params = new URLSearchParams(this.queryString);
    // Initialize properties
    this.initializeProperties();

    // Bind methods
    this.bindMethods();

    // Set up event listeners
    this.setupEventListeners();
  }

  truncateText(text, limit = 90) {
    if (!text || typeof text !== "string") return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  }

  /**
   * Initialize properties
   */
  initializeProperties() {
    this.filters = [];
    this.urlFilters = [];
    this.allFilters = [];
    this.allSubFilters = [];
    this.subFilters = [];
    this.collectionContainers = "";
    this.sort_by = "Default";
    if (window.location.href.includes("sort_by=best-selling")) {
      this.sort_by = "Bestselling";
    }
    const container = document.querySelector("#ProductGridContainer");
    this.collectionsHandles = container
      ? [container.getAttribute("data-handle")].filter(Boolean)
      : [];
    this.productsPerPage = parseInt(container?.getAttribute("data-products-per-page"), 10) || 30;
    this.productFetchSize = 250;
    this.sortRendered = false;
    this.isRestoringFromBack = false;
    this.collectionPages = {};
    this.loadMoreObservers = [];
    this.pendingHandles = [];
    this.collectionLoadId = 0;

    this.hideGlobalFilters = this.hasAttribute("data-global-filters")
      ? this.getAttribute("data-global-filters") === "false"
      : false;

    //select menu for mobile
    this.collectionSelect = document.querySelector("#collection-select");

    // Get all the coll-item elements within the custom element
    this.collItems = [...document.querySelectorAll(".coll-item")];
    this.queryString = window.location.search;
    this.params = new URLSearchParams(this.queryString);
  }

  /**
   * Bind methods
   */
  bindMethods() {
    this.getCollectionsData = this.getCollectionsData.bind(this);
    this.handleCollItemClick = this.handleCollItemClick.bind(this);
    this.handleCollSelectChange = this.handleCollSelectChange.bind(this);
    this.renderCustomSort = this.renderCustomSort.bind(this);
    this.activeFacets = this.activeFacets.bind(this);
    this.clearAllFilters = this.clearAllFilters.bind(this);
    this.onCollectionScroll = this.onCollectionScroll.bind(this);
  }

  /**
   * Set up event listeners
   */
  setupEventListeners() {
    const onFilterReady = () => {
      document.querySelector(".filters-wrapper")?.addEventListener("change", (event) => {
        if (event.target.matches('input[type="checkbox"]')) {
          this.updateUrlWithFilters();
        }
      });

      this.setAllCollectionHandles();
      this.getUrlFilterParams();
      this.unsetContainerLoading();
      this.initialCollectionRequest();
    };

    document.addEventListener("Collection:Filter:Ready", onFilterReady);

    const restoreScrollAfterRequest = (scrollX, scrollY) => {
      const restore = () => {
        this.isRestoringFromBack = false;
        requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));
      };
      return (promise) => {
        promise.then(restore).catch(restore);
      };
    };

    window.addEventListener("popstate", () => {
      const nextQueryString = window.location.search;
      if (nextQueryString === this.queryString) return;
      if (!document.querySelector("#ProductGridContainer")) return;
      this.isRestoringFromBack = true;
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;
      const grid = document.getElementById("ProductGridContainer");
      this.queryString = nextQueryString;
      this.params = new URLSearchParams(this.queryString);
      this.getUrlFilterParams();
      if (grid && this.urlFilters.length === 0) {
        grid.style.transition = "none";
        grid.style.opacity = "1";
      }
      restoreScrollAfterRequest(scrollX, scrollY)(this.initialCollectionRequest());
    });

    window.addEventListener("pageshow", (event) => {
      if (event.persisted && document.querySelector("#ProductGridContainer")) {
        this.isRestoringFromBack = true;
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;
        const grid = document.getElementById("ProductGridContainer");
        this.queryString = window.location.search;
        this.params = new URLSearchParams(this.queryString);
        if (window.location.href.includes("sort_by=best-selling")) {
          this.sort_by = "Bestselling";
        }
        this.getUrlFilterParams();
        if (grid && this.urlFilters.length === 0) {
          grid.style.transition = "none";
          grid.style.opacity = "1";
        }
        restoreScrollAfterRequest(scrollX, scrollY)(this.initialCollectionRequest());
      }
    });

    // Click event listener to each coll-item element
    this.collItems?.forEach((item) => {
      item.addEventListener("click", this.handleCollItemClick);
    });

    this.collectionSelect?.addEventListener("change", this.handleCollSelectChange);
    window.addEventListener("scroll", this.onCollectionScroll, { passive: true });
  }

  preloadFilters() {
    this.params.forEach((val, key) => {
      if (key.includes(".filter.p.tag")) {
        const input = document.querySelector(`input[value="${val}"]`);
        if (input && !input.checked) {
          input.closest(".check-container")?.click();
        }
      }
    });
  }

  setContainerLoading() {
    const grid = document.getElementById("ProductGridContainer");
    if (grid) {
      grid.style.transition = "none";
      grid.style.opacity = "0";
    }
  }

  unsetContainerLoading() {
    const grid = document.getElementById("ProductGridContainer");
    if (grid) {
      grid.style.transition = "none";
      grid.style.opacity = "1";
    }

    if (document.querySelector("[data-facets-loading]")) {
      document.querySelector("[data-facets-loading]").style.display = "none";
    }
  }

  showEmptyMessage() {
    let empty = document
      .getElementById("ProductGridContainer")
      .querySelector(".collection.collection--empty");
    if (empty) {
      empty.style.display = "";
    }
    let container = document
      .getElementById("ProductGridContainer")
      .querySelector(".collection-container");
    if (container) {
      container.style.display = "none";
    }
  }

  showCollectionContainer() {
    let empty = document
      .getElementById("ProductGridContainer")
      .querySelector(".collection.collection--empty");
    if (empty) {
      empty.style.display = "none";
    }
    let container = document
      .getElementById("ProductGridContainer")
      .querySelector(".collection-container");
    if (container) {
      container.style.display = "";
    }
  }

  /**
   * Makes the initial request for collections data and processes URL filters.
   *
   * @returns {Object} The collections data.
   */
  async initialCollectionRequest() {
    try {
      if (this.urlFilters.length > 0) {
        this.filters = [];
        this.subFilters = [];
        let result = await this.getMultipleCollectionProducts();

        this.processUrlFilters(result);

        this.activeFacets();
      }

      let result = await this.getCollectionsData(
        this.collectionsHandles,
        this.filters,
        this.subFilters,
        this.sort_by
      );

      this.unsetContainerLoading();
      this.preloadFilters();
      return result;
    } catch (error) {
      console.error("Failed to load collection data:", error);
      this.unsetContainerLoading();
      throw error;
    }
  }

  /**
   * Gets multiple collection products.
   *
   * @returns {Object} The filters and subfilters.
   */
  async getMultipleCollectionProducts() {
    let result = await window.Collection.Filter.getMultipleCollectionProducts(
      this.collectionsHandles,
      [],
      [],
      "Default",
      false,
      {},
      1,
      "set"
    );

    this.allFilters = result.filters;
    this.allSubFilters = result.subfilters;
    this.renderFilters(result.filters, result.subfilters);

    return result;
  }

  /**
   * Processes the URL filters.
   *
   * @param {Object} result - The filters and subfilters.
   */
  processUrlFilters(result) {
    this.urlFilters.forEach((filter) => {
      const singleHandle =
        this.collectionsHandles?.length === 1 ? this.collectionsHandles[0] : null;
      const isHandlePrefixed =
        singleHandle &&
        filter.name.startsWith(singleHandle + ".") &&
        filter.name.includes(".filter.");
      const effectiveFilter = isHandlePrefixed
        ? {
            name: filter.name.replace(
              new RegExp("^" + singleHandle.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\."),
              ""
            ),
            value: filter.value,
          }
        : filter;

      let isSubFilter =
        effectiveFilter.name.includes(".filter.") &&
        effectiveFilter.name.split(".")[0] !== "filter";

      if (isSubFilter) {
        this.processSubFilter(effectiveFilter, result);
      } else {
        this.processFilter(effectiveFilter, result);
      }
    });
  }

  /**
   * Processes a subfilter.
   *
   * @param {Object} filter - The filter to process.
   * @param {Object} result - The filters and subfilters.
   */
  processSubFilter(filter, result) {
    let handle = filter.name.split(".")[0];
    let findSubFilterCollection = result.subfilters.find((item) => item.handle === handle);

    if (findSubFilterCollection) {
      let findFilter = this.findFilter(filter, findSubFilterCollection.filters);

      if (findFilter) {
        this.addSubFilterValues(filter, findFilter, handle);
      }
    }
  }

  /**
   * Processes a filter.
   *
   * @param {Object} filter - The filter to process.
   * @param {Object} result - The filters and subfilters.
   */
  processFilter(filter, result) {
    let findFilter = this.findFilter(filter, result.filters);

    if (findFilter) {
      const allWithSameId = (result.filters || []).filter((f) => f.id === filter.name);
      this.addFilterValues(filter, allWithSameId.length ? allWithSameId : [findFilter]);
    }
  }

  /**
   * Finds a filter.
   *
   * @param {Object} filter - The filter to find.
   * @param {Array} filters - The filters to search in.
   * @returns {Object} The found filter.
   */
  findFilter(filter, filters) {
    let filterValues = filter.value.split(",");
    return filters.find((item) => {
      let hasSome = item.values.some((item) => filterValues.includes(item.value));
      return item.id === filter.name && hasSome;
    });
  }

  /**
   * Adds subfilter values.
   *
   * @param {Object} filter - The filter to add values from.
   * @param {Object} findFilter - The filter to find values in.
   * @param {String} handle - The handle of the subfilter.
   */
  addSubFilterValues(filter, findFilter, handle) {
    let filterValues = filter.value.split(",");
    filterValues.forEach((filterValue) => {
      let findValue = findFilter.values.find((item) => item.value === filterValue);
      if (findValue) {
        this.subFilters.push({
          handle: handle,
          input: findValue.input,
        });
      }
    });
  }

  /**
   * Adds filter values.
   *
   * @param {Object} filter - The filter to add values from.
   * @param {Object|Object[]} findFilterOrList - The filter(s) to find values in.
   */
  addFilterValues(filter, findFilterOrList) {
    let filterValues = filter.value.split(",").map((v) => v.trim());
    const list = Array.isArray(findFilterOrList) ? findFilterOrList : [findFilterOrList];
    filterValues.forEach((filterValue) => {
      for (const f of list) {
        const findValue = (f.values || []).find((item) => item.value === filterValue);
        if (findValue) {
          this.filters.push(findValue.input);
          break;
        }
      }
    });
  }

  handleCollItemClick(event) {
    event.preventDefault(); // Prevent the default behavior of the link (navigating)
    // Keep the desktop and mobile menus in sync
    const handle = event.target.getAttribute("data-handle");
    this.collItems.forEach((item) => {
      item.classList.toggle("active", item.getAttribute("data-handle") === handle);
    });

    // Updating history state
    if (event.target.getAttribute("data-handle") == "") {
      this.setAllCollectionHandles();
    } else {
      this.collectionsHandles = [event.target.getAttribute("data-handle")];
    }

    this.getCollectionsData(
      this.collectionsHandles,
      this.filters,
      this.subFilters,
      this.sort_by,
      true
    );
  }

  /**
   * Sets the `collectionContainers` property to the elements with class "collection-type" inside the element with id "ProductGridContainer".
   * Sets the `collectionsHandles` property by calling the `getAllCollectionHandles` function.
   */
  setAllCollectionHandles() {
    const gridContainer = document.getElementById("ProductGridContainer");
    this.collectionContainers = gridContainer?.querySelectorAll(".collection-type");
    const tabHandles = this.getAllCollectionHandles().filter(Boolean);
    [...(this.collectionContainers || [])].forEach((container, index) => {
      if (!container.getAttribute("data-handle") && tabHandles[index]) {
        container.setAttribute("data-handle", tabHandles[index]);
      }
    });
    const handles = [...(this.collectionContainers || [])]
      .map((container) => container.getAttribute("data-handle"))
      .filter(Boolean);
    if (handles.length) {
      this.collectionsHandles = handles;
    } else if (tabHandles.length) {
      this.collectionsHandles = tabHandles;
    } else if (gridContainer?.getAttribute("data-handle")) {
      this.collectionsHandles = [gridContainer.getAttribute("data-handle")];
    }
  }

  getKnownProductTotal() {
    const selected = [...(this.collectionsHandles || [])].filter(Boolean);
    if (selected.length === 1) {
      const container = [...(this.collectionContainers || [])].find(
        (item) => item.getAttribute("data-handle") === selected[0]
      );
      return parseInt(container?.getAttribute("data-products-count"), 10) || 0;
    }
    return (
      parseInt(
        document.getElementById("ProductGridContainer")?.getAttribute("data-products-count"),
        10
      ) || 0
    );
  }

  setProductCount(count) {
    const countEl = document.querySelector("#ProductCountDesktop");
    if (!countEl) return;
    countEl.textContent = `${Number(count) || 0} products`;
    countEl.style.display = "";
  }

  refreshProductCount() {
    const handles = [...(this.collectionsHandles || [])].filter(Boolean);
    if (!handles.length || !window.Collection?.Filter?.getUniqueProductCount) {
      this.setProductCount(this.getKnownProductTotal());
      return;
    }
    window.Collection.Filter.getUniqueProductCount(handles, this.filters, this.subFilters)
      .then((total) => this.setProductCount(total))
      .catch(() => this.setProductCount(this.getKnownProductTotal()));
  }

  /**
   * Gets the values of the "data-handle" attribute of the elements with class "coll-item".
   * @returns {Array} An array of the values of the "data-handle" attribute of the elements with class "coll-item".
   */
  getAllCollectionHandles() {
    // Desktop menu only; the mobile menu repeats the same handles
    const collectionsMenu = document.querySelectorAll(".collection-menu-desktop .coll-item");

    // Map over the elements in collectionsMenu
    // For each element, get the value of the "data-handle" attribute
    // Return the resulting array
    return Array.from(collectionsMenu).map((element) => element.getAttribute("data-handle"));
  }

  // Collection Select change
  handleCollSelectChange(event) {
    event.preventDefault(); // Prevent the default behavior of the link (navigating)

    // Updating history state

    this.collectionsHandles = [event.target.getAttribute("data-handle")];
    this.getCollectionsData(
      this.collectionsHandles,
      this.filters,
      this.subFilters,
      this.sort_by,
      true
    );
  }

  getCollectionsData(
    collectionsHandles = this.collectionsHandles,
    filters = this.filters,
    subFilters = this.subFilters,
    sort_by = this.sort_by,
    shouldLabelsRefresh = false
  ) {
    const loadId = ++this.collectionLoadId;
    const handles = [...(collectionsHandles || [])].filter(Boolean);
    if (handles.length > 1) {
      this.pendingHandles = handles.slice(1);
      collectionsHandles = [handles[0]];
    } else {
      this.pendingHandles = [];
    }

    this.unsetContainerLoading();

    const fullFiltersPromise =
      handles.length > 1
        ? window.Collection.Filter.getMultipleCollectionProducts(
            handles,
            filters,
            subFilters,
            sort_by,
            false,
            {},
            1,
            "set"
          )
        : null;

    return window.Collection.Filter.getMultipleCollectionProducts(
      collectionsHandles,
      filters,
      subFilters,
      sort_by,
      false,
      {},
      this.productFetchSize,
      "live"
    )
      .then((result) => {
        if (this.collectionLoadId !== loadId) return result;

        let { filters, subfilters, products, sort_keys, count } = result;

        this.allFilters = filters;
        this.allSubFilters = subfilters;

        this.renderProducts(products);
        this.renderFilters(filters, subfilters);
        this.refreshProductCount();

        if (count || this.pendingHandles.length) {
          this.showCollectionContainer();
        } else {
          this.showEmptyMessage();
        }

        if (this.sortRendered == false) {
          this.renderCustomSort(sort_keys);
        }

        if (typeof window?.okeWidgetApi?.initAllWidgets == "function") {
          window.okeWidgetApi.initAllWidgets();
        }

        if (shouldLabelsRefresh === true) {
          this.setMobileSort(sort_by);
        }

        this.loadRemainingCollections(loadId);
        this.tryLoadMoreOnScroll();

        if (fullFiltersPromise) {
          fullFiltersPromise
            .then((full) => {
              if (this.collectionLoadId !== loadId) return;
              this.allFilters = full.filters;
              this.allSubFilters = full.subfilters;
              this.renderFilters(full.filters, full.subfilters);
              this.refreshProductCount();
            })
            .catch(() => {
              if (this.collectionLoadId !== loadId) return;
              this.renderFilters(filters, subfilters);
            });
        }

        return result;
      })
      .catch((error) => {
        console.error("Failed to load collection products:", error);
        this.unsetContainerLoading();
        throw error;
      });
  }

  setMobileSort(sortBy) {
    const activeSortLabels = document.querySelectorAll("[data-active-sort]");
    const sortOptions = document.querySelectorAll("[data-mobile-sort]");

    Array.from(activeSortLabels).forEach((sortLabel) => (sortLabel.innerHTML = sortBy));

    Array.from(sortOptions).forEach((input) => {
      if (input.value === sortBy) {
        input.checked = true;
        input.setAttribute("checked", "true");
      } else {
        input.checked = false;
        input.removeAttribute("checked");
      }
    });
  }

  /*
   * START GB Experiment: https://app.growthbook.io/experiment/exp_19g61wm84y8vyw
   *
   * Remove this function once the experiment has concluded
   *
   */
  getBenefitCardContent() {
    const productGridContainer = document.querySelector("#ProductGridContainer");
    const handle = productGridContainer.getAttribute("data-handle");
    const benefitCardsScript = document.getElementById("benefit-cards-data");

    if (benefitCardsScript) {
      try {
        const benefitCardsJson = JSON.parse(benefitCardsScript.textContent);
        console.log(benefitCardsJson);
        return benefitCardsJson;
      } catch (error) {
        console.error("Failed to parse benefit cards JSON:", error);
      }
    }
    const socksContent = [
      {
        img: "https://good.store/cdn/shop/files/charity-svgrepo-com_1_10x.svg",
        title: "100% of Profit to Charity",
        description: "All of the profit goes towards increasing medical access in Sierra Leone.",
      },
      {
        img: "https://good.store/cdn/shop/files/socks-svgrepo-com_10x.svg",
        title: "High Quality and Comfortable",
        description: "Soft and durable, so they'll be good to wear for years to come.",
      },
      {
        img: "https://good.store/cdn/shop/files/artist-color-palette-svgrepo-com_10x.svg",
        title: "Supports Independent Artists",
        description: "Every month features a new design from a new independent artist.",
      },
    ];

    const keatsCoContent = [
      {
        img: "https://good.store/cdn/shop/files/charity-svgrepo-com_1_10x.svg",
        title: "100% of Profit to Charity",
        description: "All profit directly funds tuberculosis treatment programs in Lesotho.",
      },
      {
        img: "https://good.store/cdn/shop/files/tea-teapot-svgrepo-com_10x.svg",
        title: "High Quality Ingredients",
        description: "We work with industry experts to bring you the top shelf coffee and tea.",
      },
      {
        img: "https://good.store/cdn/shop/files/trees-forest-svgrepo-com_10x.svg",
        title: "Ethically Sourced",
        description:
          "We ensure fair labor practices, sustainable farming, and environmental protection",
      },
    ];

    const soapContent = [
      {
        img: "https://good.store/cdn/shop/files/charity-svgrepo-com_1_10x.svg",
        title: "100% of Profit to Charity",
        description: "All of the profit goes towards increasing medical access in Sierra Leone.",
      },
      {
        img: "https://good.store/cdn/shop/files/tree-plant-icon_80x.png",
        title: "All Natural Ingredients",
        description: "Made with all natural oils and butters, and scented with plant extracts.",
      },
      {
        img: "https://good.store/cdn/shop/files/eco-friendly-svgrepo-com_10x.svg",
        title: "Eco-Friendly",
        description: "All of Sun Basin's products come in eco-friendly packaging.",
      },
    ];

    switch (handle) {
      case "all-socks":
        return socksContent;
      case "all-keats-and-co":
        return keatsCoContent;
      case "all-soaps":
        return soapContent;
      default:
        return null;
    }
  }

  generateExperimentCardMarkup(content) {
    if (!content) return "";

    const { img, title, description } = content;

    return `
      <li class="grid__item benefit-card">
        <img src="${img}" class="benefit-card__image"/>
        <div class="benefit-card__title">${title}</div>
        <div class="benefit-card__description">${this.truncateText(description)}</div>
      </li>
    `;
  }
  /* END GB Experiment: https://app.growthbook.io/experiment/exp_19g61wm84y8vyw */

  /**
   * Renders the products from the given collections on the page.
   *
   * @param {Array} collections - The collections to render the products from.
   */
  renderProducts(collections, replace = true) {
    const containers = [...(this.collectionContainers || [])];

    if (replace) {
      (this.loadMoreObservers || []).forEach((observer) => observer.disconnect());
      this.loadMoreObservers = [];
      containers.forEach((container) => {
        const keep = collections.some(
          (collection) => collection.handle === container.getAttribute("data-handle")
        );
        if (!keep) container.style.display = "none";
      });
    }

    /*
     * START GB Experiment: https://app.growthbook.io/experiment/exp_19g61wm84y8vyw
     *
     * Remove this function once the experiment has concluded
     *
     */
    const benefitContent = this.getBenefitCardContent();
    if (benefitContent) {
      const benefitLength = benefitContent.length;
    }
    /* END GB Experiment: https://app.growthbook.io/experiment/exp_19g61wm84y8vyw */

    // For each collection
    collections.forEach((collection, index) => {
      let container = containers.find(
        (item) => collection.handle && item.getAttribute("data-handle") === collection.handle
      );
      if (!container && replace) container = containers[index];
      if (!container && !replace) {
        container = containers.find((item) => item.style.display === "none");
      }
      if (!container) return;
      if (collection.handle) container.setAttribute("data-handle", collection.handle);

      // Set the title of the collection container
      const h2Element = container.querySelector("h2");
      if (h2Element) {
        h2Element.innerHTML = collection.title;
      }

      // Generate the markup for the products in the collection and set it in the collection container
      container.querySelector("ul").innerHTML = collection.products
        .map((product, mapIndex, productsArray) => {
          let productMarkup = this.generateProductCardMarkup(product, mapIndex);
          let benefitCardMarkup = "";

          const benefitInsertPositions = [3, 7, 13]; // Positions where benefit cards should be inserted
          const totalProducts = productsArray.length;

          // Check if current product is in a benefit card position
          if (benefitContent?.length > 0) {
            benefitInsertPositions.forEach((position, index) => {
              if (mapIndex + 1 === position) {
                const contentIndex = index % benefitContent.length; // Cycles through benefit content
                benefitCardMarkup = this.generateExperimentCardMarkup(benefitContent[contentIndex]);
              }
            });
          }

          return `
            ${productMarkup} 
            ${benefitCardMarkup}
          `;
        })
        .join("");

      // Special case: If there are only 1 or 2 products, insert the first benefit card at the end

      if (collection.products.length <= 2 && benefitContent?.[0]) {
        container.querySelector("ul").innerHTML += this.generateExperimentCardMarkup(
          benefitContent[0]
        );
      }

      // Special case: If the total products are less than 14, insert the 3rd benefit card at the end
      if (
        collection.products.length < 14 &&
        collection.products.length > 8 &&
        benefitContent?.[2]
      ) {
        container.querySelector("ul").innerHTML += this.generateExperimentCardMarkup(
          benefitContent[2]
        );
      }

      if (collection.products.length > 0) {
        container.style.display = "block";
        container.style.visibility = "";
      }

      this.observeCollectionLoadMore(container, collection);
    });

    document.dispatchEvent(new CustomEvent("Collection:Filter:Changed"));
  }

  observeCollectionLoadMore(container, collection) {
    if (!container || !collection?.handle) return;
    this.collectionPages[collection.handle] = {
      hasNextPage:
        Boolean(collection.pageInfo?.hasNextPage) ||
        collection.products.length >= this.productFetchSize,
      endCursor: collection.pageInfo?.endCursor || null,
      loading: false,
    };
    if (!this.collectionPages[collection.handle].hasNextPage) {
      container.querySelector("[data-load-more]")?.remove();
      return;
    }

    let sentinel = container.querySelector("[data-load-more]");
    if (!sentinel) {
      sentinel = document.createElement("div");
      sentinel.setAttribute("data-load-more", collection.handle);
      sentinel.style.height = "1px";
      container.appendChild(sentinel);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) return;
        this.loadMoreCollection(collection.handle, container);
      },
      { rootMargin: "400px" }
    );
    observer.observe(sentinel);
    this.loadMoreObservers.push(observer);
  }

  async loadMoreCollection(handle, container) {
    const page = this.collectionPages[handle];
    if (!page?.hasNextPage || page.loading) return;
    page.loading = true;

    try {
      const result = await window.Collection.Filter.getMultipleCollectionProducts(
        [handle],
        this.filters,
        this.subFilters,
        this.sort_by,
        false,
        { [handle]: page.endCursor },
        this.productFetchSize
      );
      const next = result.products?.[0];
      if (!next?.products?.length) {
        page.hasNextPage = false;
        return;
      }

      const list = container.querySelector("ul");
      if (list) {
        list.insertAdjacentHTML(
          "beforeend",
          next.products.map((product) => this.generateProductCardMarkup(product, 8)).join("")
        );
      }

      page.hasNextPage = Boolean(next.pageInfo?.hasNextPage);
      page.endCursor = next.pageInfo?.endCursor || null;
      if (!page.hasNextPage) {
        container.querySelector("[data-load-more]")?.remove();
      }

      if (typeof window?.okeWidgetApi?.initAllWidgets == "function") {
        window.okeWidgetApi.initAllWidgets();
      }
    } catch (error) {
      console.error("Failed to load more products:", error);
    } finally {
      page.loading = false;
      this.tryLoadMoreOnScroll();
    }
  }

  onCollectionScroll() {
    if (this.scrollLoadQueued) return;
    this.scrollLoadQueued = true;
    requestAnimationFrame(() => {
      this.scrollLoadQueued = false;
      this.tryLoadMoreOnScroll();
    });
  }

  tryLoadMoreOnScroll() {
    const containers = [...(this.collectionContainers || [])];
    const visible = containers.filter((el) => getComputedStyle(el).display !== "none");
    visible.forEach((container) => {
      if (container.getBoundingClientRect().bottom > window.innerHeight + 500) return;
      const handle = container.getAttribute("data-handle");
      const page = handle && this.collectionPages[handle];
      if (page?.hasNextPage) {
        this.loadMoreCollection(handle, container);
      }
    });
  }

  async loadRemainingCollections(loadId) {
    const remaining = [...(this.pendingHandles || [])];
    if (!remaining.length) return;

    try {
      const result = await window.Collection.Filter.getMultipleCollectionProducts(
        remaining,
        this.filters,
        this.subFilters,
        this.sort_by,
        false,
        {},
        this.productFetchSize,
        "use"
      );
      if (this.collectionLoadId !== loadId) return;
      this.pendingHandles = [];
      if (result.products?.length) {
        this.renderProducts(result.products, false);
      }
      if (typeof window?.okeWidgetApi?.initAllWidgets == "function") {
        window.okeWidgetApi.initAllWidgets();
      }
    } catch (error) {
      console.error("Failed to load remaining collections:", error);
    }
  }

  /**
   * Renders the filters and subfilters on the page.
   *
   * @param {Array} filters - The filters to render.
   * @param {Array} subfilters - The subfilters to render.
   */
  renderFilters(filters, subfilters) {
    // Get the filters wrapper
    let filtersWrapper = document.querySelector(".filters-wrapper");
    filtersWrapper.innerHTML = "";

    // Check template - only skip filters for holiday-collection template
    const template =
      document.body?.getAttribute("data-template") ||
      document.querySelector("[data-template]")?.getAttribute("data-template");
    const isHolidayCollection = template === "collection.holiday-collection";
    const hiddenFilterLabels = ["Tea Type", "Style", "Size", "Caffeine"];

    // Render the filters
    if (!this.hideGlobalFilters && !this.shouldShowSubFilters) {
      filters.forEach((filter, index) => {
        if (filter.label.includes(this.filterLabelForGrowthbook)) {
          // Skip only for holiday-collection template when filter matches hidden labels
          if (isHolidayCollection && hiddenFilterLabels.includes(filter.label)) {
            return;
          }
          this.renderFilterContainer(filter, filtersWrapper);
          this.addFilterDivider(0, filters.length, filtersWrapper);
        }
      });
      filters.forEach((filter, index) => {
        if (!filter.label.includes(this.filterLabelForGrowthbook)) {
          if (isHolidayCollection && hiddenFilterLabels.includes(filter.label)) {
            return;
          }
          this.renderFilterContainer(filter, filtersWrapper);
          this.addFilterDivider(index, filters.length, filtersWrapper);
        }
      });
    }

    // Render the subfilters
    if (this.shouldShowSubFilters) {
      subfilters.forEach((subfilter) => {
        subfilter.filters.forEach((filter, index) => {
          if (filter.values.length > 0) {
            if (filter.label.includes(this.filterLabelForGrowthbook)) {
              // Skip only for holiday-collection template when filter matches hidden labels
              if (isHolidayCollection && hiddenFilterLabels.includes(filter.label)) {
                return;
              }
              this.renderFilterContainer(
                filter,
                filtersWrapper,
                index === 0 ? subfilter.title : false,
                subfilter.handle
              );
              this.addFilterDivider(0, subfilter.filters.length, filtersWrapper);
            }
          }
        });

        subfilter.filters.forEach((filter, index) => {
          if (filter.values.length > 0) {
            if (!filter.label.includes(this.filterLabelForGrowthbook)) {
              // Skip only for holiday-collection template when filter matches hidden labels
              if (isHolidayCollection && hiddenFilterLabels.includes(filter.label)) {
                return;
              }
              this.renderFilterContainer(
                filter,
                filtersWrapper,
                index === 0 ? subfilter.title : false,
                subfilter.handle
              );
              this.addFilterDivider(index, subfilter.filters.length, filtersWrapper);
            }
          }
        });
      });
    }

    this.facetsAccordion();
  }

  /**
   * Renders a filter container.
   *
   * @param {Object} filter - The filter to render.
   * @param {HTMLElement} filtersWrapper - The filters wrapper.
   * @param {string} [title=false] - The title of the filter.
   * @param {string} [subfilter=false] - The subfilter of the filter.
   */
  urlContainsPath() {
    const pathsToCheck = [
      "/collections/all-socks",
      "/collections/all-coffee",
      "/collections/all-keats-and-co",
      "/collections/all-soaps",
      "/collections/ecogeek",
    ];
    const currentURL = window.location.href;
    return pathsToCheck.some((path) => currentURL.includes(path));
  }

  renderFilterContainer(filter, filtersWrapper, title = false, subfilter = false) {
    // Check if the title should be displayed based on the current URL
    const titleToDisplay = !this.urlContainsPath() ? title : "";

    // Create a new div element to hold the filter HTML
    let filterContainer = document.createElement("div");
    filterContainer.classList.add("filter-container", "active");
    filterContainer.setAttribute("data-label", filter.label);

    // add a hidden tag if filter is availability

    if (filter.label.includes(this.filterLabelForGrowthbook)) {
      filterContainer.classList.add("availability-filter");
    }

    filterContainer.innerHTML = `
      <div class="filter-header" tabindex="0" role="button" aria-expanded="true">
        <span class="filter-title">${filter.label}</span>
        <span class="filter-icon">
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4L8 8L12 4" stroke="#202020" />
          </svg>
        </span>
      </div>
      <div class="filter-content">
        <ul class="filter-values">
          ${filter.values
            .map((value) => {
              // Check if the filter is in the URL
              let isChecked = this.checkForFiltersUrl(filter.id, value.value);
              return `
                <li class="filter-value">
                  <label class="check-container">
                    <input type="checkbox" ${
                      subfilter ? `data-sub-filter="${subfilter}"` : ""
                    } data-input='${value.input}' data-param="${
                      value.param
                    }" name="${filter.id}" value='${value.value}' ${isChecked ? "checked" : ""}>
                    <span class="checkmark"></span>
                    <span class="filter-value-text">${
                      value.label === "Out of stock" ? "Low in stock" : value.label
                    }</span>
                  </label>
                </li>`;
            })
            .join("")}
        </ul>
      </div>
    `;

    // Append the new filter container to the filters wrapper
    filtersWrapper.appendChild(filterContainer);
    return filterContainer;
  }

  /**
   * Adds a filter divider.
   *
   * @param {number} index - The index of the filter.
   * @param {number} length - The total number of filters.
   * @param {HTMLElement} filtersWrapper - The filters wrapper.
   */
  addFilterDivider(index, length, filtersWrapper) {
    // Add a filter divider if it's not the last filter
    if (index < length - 1) {
      let divider = document.createElement("div");
      divider.classList.add("filter-divider");
      divider.textContent = ".";
      filtersWrapper.appendChild(divider);
    }
  }

  get shouldShowSubFilters() {
    const allHandles = this.getAllCollectionHandles().filter(Boolean);
    const selectedHandles = [...(this.collectionsHandles || [])].filter(Boolean);
    if (!selectedHandles.length || allHandles.length === selectedHandles.length) {
      return false;
    }

    return true;
  }

  /*
   * GB experiment: https://app.growthbook.io/experiment/exp_19g61wm6f08s47#overview
   *
   * Remove this script once the experiment has concluded
   */

  isHoverBundleProduct(product) {
    if (product?.type === "Bundle") return true;
    return (product?.metafields || []).some(
      (metafield) =>
        metafield &&
        metafield.key === "recharge_bundle" &&
        String(metafield.value).toLowerCase() === "true"
    );
  }

  hoverAtcMarkup(product) {
    if (!product?.available || !product?.featured_image?.url) return "";
    const handle = String(product.handle || "").replace(/"/g, "&quot;");
    const url = String(product.url || `/products/${product.handle}`).replace(/"/g, "&quot;");
    return `<card-hover-atc
      class="card-hover-atc"
      data-handle="${handle}"
      data-url="${url}"
      data-product-id="${product.id}"
      data-available="${product.available}"
      data-is-bundle="${this.isHoverBundleProduct(product)}"
    ></card-hover-atc>`;
  }

  hoverAtcTriggerMarkup(product) {
    if (!product?.available) return "";
    const strings = window.cardHoverAtcStrings || {};
    const isBundle = this.isHoverBundleProduct(product);
    let label = strings.addToCart || "Add to cart";
    if (isBundle) {
      label = strings.bundleAndSave || "Bundle & Save";
    }
    label = String(label).replace(/&amp;/g, "&");
    const url = String(product.url || `/products/${product.handle}`).replace(/"/g, "&quot;");
    const safeLabel = label.replace(/&/g, "&amp;").replace(/</g, "&lt;");
    return `<div class="card-hover-atc__anchor"><div class="card-hover-atc__mobile-panel" data-card-hover-slot></div><button type="button" class="card-hover-atc__mobile-trigger card-hover-atc__submit" data-card-hover-trigger data-url="${url}"><span class="card-hover-atc__submit-label">${safeLabel}</span></button></div>`;
  }

  // Function to generate HTML markup based on the product and settings
  generateProductCardMarkup(product, mapIndex = 0) {
    if (!product.url) return "";

    let ratingItem = product.metafields.find((item) => item.key === "rating");
    let ratingCount = product.metafields.find((item) => item.key === "summaryData");

    let markup = "";
    // Check if the "rating" object exists
    if (ratingItem) {
      // Parse the JSON value from the "rating" object
      let ratingValue = JSON.parse(ratingItem.value);

      // Create the HTML markup
      markup = `<div class="rating hide hidden" role="img" aria-label="${
        ratingValue.value
      } out of 5.0 stars">
                <span aria-hidden="true" class="rating-star color-icon-text" style="--rating: ${Math.floor(
                  ratingValue.value
                )}; --rating-max: 5.0; --rating-decimal: ${ratingValue.value % 1};"></span>
            </div>

            <div data-oke-star-rating data-oke-reviews-product-id="shopify-${product.id}"></div>
        `;

      // Append the markup to the body or any other container
    }
    if (ratingCount) {
      // console.log(ratingCount);
      // Parse the JSON value from the "rating" object
      let countValue = JSON.parse(ratingCount.value);

      // Create the HTML markup
      markup += `<p class="rating-count caption">
        <span aria-hidden="true">(${countValue.reviewCount})</span>
        <span class="visually-hidden">${countValue.reviewCount}
          total reviews</span>
      </p>
        `;

      // Append the markup to the body or any other container
    }
    // console.log("markup", markup);

    const isComingSoon = (product.tags || []).some(
      (tag) => String(tag).toLowerCase() === "badge_coming soon"
    );
    const isSoldOut = !product.available && !isComingSoon;

    let mediaContent = "";
    if (product?.featured_image?.url) {
      mediaContent = `<div class="card__media" data-multiple-collection>
        <div class="media media--transparent media--hover-effect">
            ${!product.available ? `<div class="media--sold-overlay"></div>` : ""}
            <img
                src="${product.featured_image.url}?width=533"
                alt="${product.featured_image.altText}"
                class="motion-reduce"
                loading="${mapIndex > 3 ? "lazy" : "eager"}"
                width="${
                  isNaN(product.featured_image.width)
                    ? product.featured_image.width
                    : parseInt(product.featured_image.width) * 2
                }"
                height="${
                  isNaN(product.featured_image.height)
                    ? product.featured_image.height
                    : parseInt(product.featured_image.height) * 2
                }"
            >
          </div>
        </div>
      `;
    }

    const content = `
<li class="grid__item">
<div class="card-wrapper product-card-wrapper underline-links-hover ${
      isSoldOut ? "sold_out" : ""
    } ">
    <div class="card card--standard card--media " style="--ratio-percent: 100%;">
        <div class="card__inner   ratio" style="--ratio-percent: 100%;">
            ${mediaContent}
            ${this.hoverAtcMarkup(product)}
            <div class="card__content">
                <div class="card__information">
                    <h3 class="card__heading" >
                        <a href="/products/${product.handle}"  class="full-unstyled-link" >
                            ${product.title}
                        </a>
                    </h3>
                </div>
                <div class="card__badge top left">
                    ${
                      isSoldOut
                        ? `
                        <span  class="badge badge_soldout badge--sold-out badge--bottom-left color-">
                            Sold out
                        </span>`
                        : ""
                    }
                    ${
                      product.compare_at_price.amount > product.price.amount
                        ? `
                        <span class="badge badge_sale badge--sale badge--bottom-left color-">
                            Sale
                        </span>`
                        : ""
                    }

                    <!-- get other badges -->
                    ${product.tags
                      .map((tag) => {
                        if (!tag.includes("badge_")) return "";
                        const currentBadge = tag.split("_").pop();
                        const badgeClass = `badge_${String(currentBadge).replace(/\s/g, "-")}`;
                        const label = String(currentBadge).replace(/-/g, " ");
                        return `<span class="badge ${badgeClass}">${label}</span>`;
                      })
                      .join("")}
       
                </div>
                <div class="card__badge card__badge--desktop bottom left">
                ${product.tags
                  .reverse()
                  .map((tag) => {
                    if (tag.includes("tag_")) {
                      const currentBadge = tag.split("_").pop();
                      let tagClass = tag.replace(/\s/g, "-");
                      let badgeClass = `badgebtm--${currentBadge.replace(/\s/g, "-")}`;
                      return `<span class="badge btm_badge ${badgeClass} ${tagClass}">${currentBadge}</span>`;
                    }
                  })
                  .join("")}
                </div>
            </div>
        </div>
        <div class="card__content">
            <div class="card__information">
              <div class="card__badge--mobile">
              ${product.tags
                .reverse()
                .map((tag) => {
                  if (tag.includes("tag_")) {
                    const currentBadge = tag.split("_").pop();
                    let tagClass = tag.replace(/\s/g, "-");
                    let badgeClass = `badgebtm--${currentBadge.replace(/\s/g, "-")}`;
                    return `<span class="badge btm_badge ${badgeClass} ${tagClass}">${currentBadge}</span>`;
                  }
                })
                .join("")}
              </div>
              <div class="card_title">
                <h3 class="card__heading h5 foo">
                    <a href="/products/${product.handle}"  class="full-unstyled-link" >
                        ${product.title}
                    </a>
                </h3>
                ${markup}
              </div>  
              <!-- Include the function to render the price -->
              ${this.renderPrice(product)}
              ${this.hoverAtcTriggerMarkup(product)}
            </div>
            
            <div class="card__badge top left">
                ${
                  !product.available
                    ? `<span id="Badge-" class="badge badge--bottom-left color-">
                       Soldout
                    </span>`
                    : ""
                }
                ${
                  product.compare_at_price > product.price && product.available
                    ? `
                    <span id="Badge-" class="badge badge--bottom-left color-">
                        Sale
                    </span>`
                    : ""
                }
            </div>
        </div>
    </div>
</div>
</li>
`;

    return content;
  }

  /**
   * Function to render the price of a product.
   *
   * @param {Object} product - The product object.
   * @param {Object} product.price - The price object of the product.
   * @param {number} product.price.amount - The amount of the product price.
   * @param {Object} product.compare_at_price - The compare at price object of the product.
   * @param {number} product.compare_at_price.amount - The amount of the compare at price.
   * @param {Object} [product.default_selling_plan] - The default selling plan of the product.
   * @param {number} [product.default_selling_plan.displayPrice] - The computed plan display price.
   * @param {boolean} [product.default_selling_plan.showPlusSuffix] - Whether to append "+" to the price.
   * @returns {string} The HTML string to display the price.
   */
  renderPrice(product) {
    // Validate if product exists and has necessary properties
    let dataPriceAttr = 0;
    if (!product || !product.price || !product.compare_at_price) {
      console.error("Invalid product data");
      return "";
    }

    // Initialize price classes and product price
    let priceClasses = "price";
    let productPrice = product.price.amount;
    let displayPrice = productPrice;
    let showPlusSuffix = false;

    // Check if product is on sale
    if (product.compare_at_price.amount > product.price.amount) {
      priceClasses += " price--sold-out price--on-sale";
    }
    dataPriceAttr = parseFloat(product.price.amount) * 100;

    const sellingPlan = product?.default_selling_plan;
    if (sellingPlan?.displayPrice != null) {
      showPlusSuffix = sellingPlan.showPlusSuffix === true;
      dataPriceAttr = parseFloat(sellingPlan.displayPrice) * 100;

      if (showPlusSuffix) {
        productPrice = Math.floor(Number(sellingPlan.displayPrice));
        displayPrice = `${productPrice.toFixed(2)}+`;
      } else {
        productPrice = parseFloat(sellingPlan.displayPrice).toFixed(2);
        displayPrice = productPrice;
      }
    }
    // Return a string of HTML to display the price
    return `
        <div class="${priceClasses}">
            <div class="price__container">
                <div class="price__regular">
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span class="price-item price-item--regular" data-currency-price="${
                      Number(productPrice) <= 0
                        ? "Bundle & Save"
                        : `${dataPriceAttr}${showPlusSuffix ? "+" : ""}`
                    }">
                    ${
                      Number(productPrice) <= 0
                        ? "Bundle & Save"
                        : `${product.price.currencyCode} ${displayPrice}`
                    }
                    </span>
                </div>
                <div class="price__sale">
                    <span class="visually-hidden visually-hidden--inline">Sale price</span>
                    <span class="price-item price-item--sale price-item--last" data-currency-price="${
                      Number(productPrice) <= 0
                        ? "Bundle & Save"
                        : `${dataPriceAttr}${showPlusSuffix ? "+" : ""}`
                    }">
                    ${product.price.currencyCode} ${displayPrice}
                    </span>
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span>
                        <s class="price-item price-item--regular" data-currency-price="${
                          product.compare_at_price.amount * 100
                        }">
                         ${product.compare_at_price.currencyCode} ${product.compare_at_price.amount}
                        </s>
                    </span>
                </div>
                <small class="unit-price caption hidden">
                    <span class="visually-hidden">Unit price</span>
                    <span class="price-item price-item--last">
                        <span></span>
                        <span aria-hidden="true">/</span>
                        <span class="visually-hidden">&nbsp;per&nbsp;</span>
                        <span>
                        </span>
                    </span>
                </small>
            </div>
        </div>
      `;
  }

  /**
   * Updates the URL with the currently selected filters.
   * It also updates the 'urlFilters' and 'filters' properties of the object, and fetches the collections data with the new filters.
   */
  updateUrlWithFilters() {
    // Create a new Map to store the filter parameters
    let filterParams = new Map();

    // For each checked checkbox
    [...document.querySelectorAll('input[type="checkbox"]:checked')].forEach((checkbox) => {
      // If the filter parameter for the checkbox name already exists
      if (filterParams.has(checkbox.name)) {
        // Get the current value of the filter parameter
        let filterParamsValue = filterParams.get(checkbox.name);
        // Add the checkbox value to the filter parameter value and update the filter parameter
        filterParams.set(
          checkbox.name,
          [...filterParamsValue.split(","), checkbox.value].join(",")
        );
      } else {
        // Otherwise, add a new filter parameter with the checkbox name and value
        filterParams.set(checkbox.name, checkbox.value);
      }
    });

    // Update the 'urlFilters' property with the filter parameters
    this.urlFilters = Array.from(filterParams, ([name, value]) => ({
      name,
      value,
    }));

    // Update the 'filters' property with the data-input attributes of the checked checkboxes
    this.filters = [...document.querySelectorAll('input[type="checkbox"]:checked')]
      .map((checkbox) => {
        if (checkbox.hasAttribute("data-sub-filter")) {
          return false;
        }
        return checkbox.getAttribute("data-input");
      })
      .filter(Boolean);

    this.subFilters = [...document.querySelectorAll('input[type="checkbox"]:checked')]
      .filter((checkbox) => {
        return checkbox.hasAttribute("data-sub-filter");
      })
      .map((checkbox) => {
        return {
          handle: checkbox.getAttribute("data-sub-filter"),
          input: checkbox.getAttribute("data-input"),
        };
      });

    // Convert the filter parameters to a query string
    let queryString = Array.from(filterParams, ([name, value]) => `${name}=${value}`).join("&");

    // Get the 'view' parameter from the URL
    let view = this.getViewUrlParam();
    // If the 'view' parameter exists, add it to the query string
    if (view) {
      queryString = `${queryString}&view=${view}`;
    }

    // Create the new URL with the query string
    const newUrl = `${window.location.pathname}?${queryString}`;
    // Update the URL without reloading the page
    history.pushState(null, "", newUrl);

    // Fetch the collections data with the new filters
    this.getCollectionsData(
      this.collectionsHandles,
      this.filters,
      this.subFilters,
      this.sort_by,
      true
    );

    // Update the active facets
    this.activeFacets();
  }

  /**
   * Retrieves the 'view' parameter from the current URL.
   *
   * @returns {string} The value of the 'view' parameter, or null if the parameter does not exist.
   */
  getViewUrlParam() {
    // Get the search string from the current URL
    let url = window.location.search;

    // Create a new URLSearchParams object with the search string
    let params = new URLSearchParams(url);

    // Use the get method of the URLSearchParams object to get the value of the 'view' parameter
    let view = params.get("view");

    // Return the value of the 'view' parameter
    return view;
  }

  /**
   * Checks if a given filter and value exist in the URL filters.
   *
   * @param {string} filterId - The ID of the filter.
   * @param {string} inputValue - The value of the filter.
   * @returns {boolean} True if the filter and value exist in the URL filters, otherwise false.
   */
  checkForFiltersUrl(filterId, inputValue) {
    // Use the Array.prototype.find method to find a filter in the URL filters that matches the given filter ID and value
    let filterExists = this.urlFilters.find((filter) => {
      // Check if the filter's name matches the given filter ID and if the filter's value includes the given input value
      return filter.name === filterId && filter.value.split(",").includes(inputValue);
    });

    // If a matching filter was found, return true, otherwise return false
    return filterExists !== undefined;
  }

  /**
   * Renders custom sort options.
   *
   * @param {Array} sortOptions - The sort options to render.
   */
  renderCustomSort(sortOptions) {
    const sort_by = "CREATED_AT"; // Replace this with your actual selected sort option
    const sortUl = document.querySelector("#cstmSort");

    // Validate if sortUl exists
    if (!sortUl) {
      console.error("Sort list not found");
      return;
    }

    // Loop through the sort options and create li elements
    sortOptions.forEach((option) => {
      const liElement = document.createElement("li");

      // Set the data-value attribute of the li element
      liElement.setAttribute("data-value", option);

      // Special case for "Bestselling" option when URL includes "sort_by=best-selling"
      // reflects the fact that the "Best Selling" option in the URL is represented as "sort_by=best-selling", but we want to display it as "Bestselling" in the sort options
      if (window.location.href.includes("sort_by=best-selling")) {
        const bestsellingOption = "Bestselling";
        if (option === bestsellingOption) {
          liElement.setAttribute("selected", "selected");
          const selectedOptionElement = document.querySelector(".selectedOption");
          if (selectedOptionElement) {
            selectedOptionElement.textContent = bestsellingOption;
          }
        }
      }

      // If the option is the selected sort option, set the selected attribute of the li element
      if (option === sort_by) {
        liElement.setAttribute("selected", "selected");
      }

      // Set the class of the li element
      liElement.setAttribute("class", "sort-list-desktop-item");
      liElement.setAttribute("tabindex", "0");

      // Set the text content of the li element
      liElement.textContent = option;

      // Append li element to ul element
      sortUl.appendChild(liElement);

      // Add a click event listener to the li element
      liElement.addEventListener("click", (event) => {
        // Update the sort_by property with the data-value attribute of the clicked li element
        this.sort_by = event.target.getAttribute("data-value");

        // Fetch the collections data with the new sort option
        this.getCollectionsData(
          this.collectionsHandles,
          this.filters,
          this.subFilters,
          this.sort_by,
          true
        );

        // Update the text content of the selectedOption element with the new sort option
        const selectedOptionElement = document.querySelector(".selectedOption");
        if (selectedOptionElement) {
          selectedOptionElement.textContent = this.sort_by;
        }
      });
    });

    this.sortRendered = true;
  }

  /**
   * Adds a click event listener to each filter header.
   * When a filter header is clicked, the "active" class is toggled on the corresponding filter container.
   */
  facetsAccordion() {
    // Get all elements with class "filter-container"
    const filterContainers = document.querySelectorAll(".filter-container");

    // For each element in filterContainers
    filterContainers?.forEach((filterContainer) => {
      // Get the first element with class "filter-header" inside filterContainer
      const filterHeader = filterContainer.querySelector(".filter-header");

      // If filterHeader exists
      if (filterHeader) {
        const toggleFilterContainer = () => {
          // Toggle the "active" class on filterContainer
          const isActive = filterContainer.classList.toggle("active");
          filterHeader.setAttribute("aria-expanded", isActive);
        };

        // Filters are expanded by default (existing behavior); "active" represents expanded.
        filterContainer.classList.add("active");
        filterHeader.setAttribute("aria-expanded", "true");

        // Add a click event listener to filterHeader
        filterHeader.addEventListener("click", toggleFilterContainer);

        // Add a keydown event listener so Enter/Space also toggle it (filterHeader is a div with role="button")
        filterHeader.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggleFilterContainer();
          }
        });
      }
    });
  }

  /**
   * Finds a filter value in the allFilters array.
   *
   * @param {string} name - The name of the filter.
   * @param {string} value - The value of the filter.
   * @returns {object} The filter object if found, otherwise undefined.
   */
  findFilterValue(name, value) {
    // Use the Array.prototype.find method to find the filter with the given name and value
    let filter = this.allFilters.find((filterItem) => {
      // Find the value in the current filter's values
      let filterValue = filterItem.values.find((valueItem) => valueItem.value === value);

      // If the current filter's id matches the given name and the value was found
      if (filterItem.id === name && filterValue) {
        // Return the current filter
        return filterItem;
      }

      // Otherwise, return false to continue to the next filter
      return false;
    });

    // Return the found filter, or undefined if no filter was found
    return filter;
  }

  /**
   * Displays the active facets based on the URL filter parameters. It generates HTML for each active facet and appends it to the active facets container.
   * If there are any active facets, it also adds a 'Clear filters' button to the container.
   */
  activeFacets() {
    // Get the URL filter parameters
    const params = this.getUrlFilterParams();

    // Get the active facets container and clear its current content
    const activeFacetsContainer = document.getElementById("active-facets");
    activeFacetsContainer.innerHTML = "";

    // For each filter parameter
    params.forEach((param) => {
      let value = param.value.split(",");
      value.forEach((facetValue) => {
        let filter = this.findFilterValue(param.name, facetValue);
        if (filter) {
          let filterValue = filter.values.find((item) => item.value === facetValue);
          if (filterValue) {
            // Update the facet value to the filter value label
            facetValue = filterValue.label;
            // Generate HTML for the facet and append it to the container
            if (Number(facetValue) === 1) {
              activeFacetsContainer.append(this.generateFacetHTML(filter.label, true, filterValue));
            } else if (Number(facetValue) === 0) {
              activeFacetsContainer.append(
                this.generateFacetHTML(filter.label, false, filterValue)
              );
            } else {
              activeFacetsContainer.append(
                this.generateFacetHTML(filter.label, facetValue, filterValue)
              );
            }
          }
        }
      });
    });

    // If there are any active facets, add a 'Clear filters' button to the container
    if (params.length > 0) {
      let removeLink = document.createElement("div");
      removeLink.classList.add("active-facets__button-remove", "underlined-link");
      removeLink.setAttribute("role", "button");
      removeLink.setAttribute("tabindex", "0");
      removeLink.innerHTML = `<span>Clear filters</span>`;
      removeLink.addEventListener("click", () => this.clearAllFilters(removeLink));
      removeLink.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          this.clearAllFilters(removeLink);
        }
      });
      activeFacetsContainer.append(removeLink);
    }
  }

  renderActiveFacets() {
    return `
      <facet-remove>
          <a href="/collections/all?${key}=${value}" class="active-facets__button active-facets__button--light" role="button">
              <span class="active-facets__button-inner">
                  ${key.replace(/_/g, " ")}: ${value}
                  <svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                      <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span class="visually-hidden">Remove filter</span>
              </span>
          </a>
      </facet-remove>
    `;
  }

  /**
   * Generates HTML for a facet.
   *
   * @param {string} key - The facet key.
   * @param {string} value - The facet value.
   * @param {object} filter - The filter object.
   * @returns {HTMLElement} The HTML element for the facet.
   */
  generateFacetHTML(key, value, filter) {
    // Create a div element
    let div = document.createElement("div");

    // SVG markup for the close icon
    let svgMarkup = `
        <svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        <span class="visually-hidden">Remove filter</span>`;

    // Add classes and attributes to the div
    div.classList.add("active-facets__button-inner");
    div.setAttribute("role", "button");
    div.setAttribute("tabindex", "0");
    div.setAttribute("data-current-filter", value);

    // Set the inner HTML of the div
    div.innerHTML = `${key}: ${value}`;

    // Create a span element for the remove link
    let removeLink = document.createElement("span");
    removeLink.classList.add("removeLink");
    removeLink.innerHTML = svgMarkup;

    const removeFilter = () => {
      let elementCheckBox = document.querySelector(
        `input[type="checkbox"][name="${filter.key}"][value="${filter.value}"]`
      );
      if (elementCheckBox) {
        elementCheckBox.click();
      }
    };

    // Add an event listener to the div to remove the filter when clicked
    div.addEventListener("click", removeFilter);
    div.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        removeFilter();
      }
    });

    // Append the remove link to the div
    div.append(removeLink);

    // Create an extra span element for accessibility
    let extraSpan = document.createElement("span");
    extraSpan.classList.add("visually-hidden");
    extraSpan.textContent = `Remove filter`;

    // Append the extra span to the div
    div.append(extraSpan);

    // Return the div
    return div;
  }

  /**
   * Extracts filter parameters from the current URL. It looks for parameters that include 'filter.' in their key.
   *
   * @returns {Array} An array of filter parameters, each represented as an object with a name and value.
   */
  getUrlFilterParams() {
    // Get the current URL's search parameters
    let url = window.location.search;
    let params = new URLSearchParams(url);

    // Initialize a new Map to store the filter parameters
    let filterParams = new Map();

    // Iterate over the search parameters
    params.forEach((value, key) => {
      // If the key includes 'filter.', add it to the filter parameters
      if (key.includes("filter.")) {
        filterParams.set(key, value);
      }
    });

    this.urlFilters = Array.from(filterParams, ([name, value]) => ({
      name,
      value,
    }));

    return this.urlFilters;
  }

  clearAllFilters() {
    this.filters = [];
    this.urlFilters = [];

    [...document.querySelectorAll('input[type="checkbox"]:checked')].forEach((checkbox) => {
      checkbox.checked = false;
    });

    this.updateUrlWithFilters();
  }
}

customElements.define("dynamic-collection", DynamicCollection);
